export interface ApiCreateToDoRequest {
  todoType: 'G';
  acknowledgedFlag: null;
  followupDate: null;
  patientId: number;
  statusInd: 'O';
  todoNote: string;
  imageFilename: null;
  priorityInd: 'M';
  imageFileLocation: null;
  dueDate: null;
  trackFlag: null;
  assignedTo: -231;
  followupNote: 'Increase Site Change';
}

export const buildCreateToDoRequest = (patientId: number, pumpSiteChangeFrequency: number): ApiCreateToDoRequest => ({
  todoType: 'G',
  acknowledgedFlag: null,
  followupDate: null,
  patientId: patientId,
  statusInd: 'O',
  todoNote: `Patient is changing every ${pumpSiteChangeFrequency} days`,
  imageFilename: null,
  priorityInd: 'M',
  imageFileLocation: null,
  dueDate: null,
  trackFlag: null,
  assignedTo: -231,
  followupNote: 'Increase Site Change',
});
